<template>
  <loader
    v-if="!profileId || loading"
    :class="$style.loader"
  />
  <div
    v-else
    :class="$style.card"
  >
    <div :class="$style.buttonsContainer">
      <button
        :class="[$style.addUserButton, $style.buttonContainer]"
        @click="openModal"
      >
        {{ $t('settings.criticalEvents.addRection') }}
      </button>
    </div>
    <dragTreeTable
      :data="treeData"
      @deleteItem="deleteItem"
      @editItem="editEvent"
    >
      <template #data="{ row, column }">
        {{ getDataField(row, column.field) }}
      </template>
    </dragTreeTable>

    <add-reaction
      v-if="isViewModal"
      :class="$style.modal"
      :critical-events="treeData.lists"
      :event="currentEvent"
      :is-delete="isDelEvent"
      @update="updateCriticalEvents"
      @close="closeModal"
    />
  </div>
</template>

<script>
  import { getCriticalEvents } from '@/api/methods/settings';
  import dragTreeTable from '@/components/pages/agents/drag-tree-table/dragTreeTable.vue';
  import Loader from '@/components/common/blocks/loader.vue';
  import AddReaction from './add-reaction.vue';

  export default {
    components: {
      dragTreeTable,
      AddReaction,
      Loader,
    },
    data() {
      return {
        loading: false,
        isViewModal: false,
        currentEvent: null,
        isDelEvent: false,
        initData: [],
        treeData: {
          columns: [
            {
              title: this.$t('settings.columns.eventType'),
              field: 'eventType',
              maxWidth: '50%',
              padding: '5px',
              align: 'left',
              flex: 1,
              type: 'data',
            },
            {
              title: this.$t('settings.columns.reactionType'),
              field: 'reaction',
              maxWidth: '50%',
              padding: '5px',
              align: 'left',
              flex: 1,
              type: 'data',
            },
            {
              type: 'action',
              title: this.$t('settings.columns.action'),
              maxWidth: '10%',
              padding: '5px',
              align: 'left',
              flex: 1,
              actions: [
                {
                  text: this.$t('settings.columns.actions.changeName'),
                  eventName: 'editItem',
                  formatter: () => '',
                },
                {
                  text: this.$t('settings.columns.actions.deleteItem'),
                  eventName: 'deleteItem',
                  formatter: () => '',
                },
              ],
            },
          ],
          lists: [],
          custom_field: {
            id: 'ident',
            lists: 'children',
            parent_id: 'category',
          },
        },
        columns: [
          { name: this.$t('settings.columns.eventType'), field: 'eventType' },
          { name: this.$t('settings.columns.reactionType'), field: 'reaction' },
        ],
      };
    },
    computed: {
      profileId() {
        return this.$store.getters['settings/profile'];
      },
      selectedComputer() {
        return {
          type: this.$route.params.type,
          id: this.$route.params.computer,
        };
      },
    },
    async created() {
      await this.getCriticalEventsData();
    },
    async mounted() {
      this.$store.subscribeAction({
        // eslint-disable-next-line
        after: async (action, state) => {
          if (action.type === 'settings/cancel') {
            this.treeData.lists = this.initData;
          }
        },
      });
      this.$store.subscribeAction({
        // eslint-disable-next-line
        after: async (action, state) => {
          if (action.type === 'settings/paramChanged') {
            this.initData = this.treeData.lists;
          }
        },
      });
    },
    methods: {
      openModal() {
        this.isViewModal = true;
      },
      closeModal() {
        this.isViewModal = false;
        this.currentEvent = null;
        this.isDelEvent = false;
      },
      deleteItem(event) {
        this.currentEvent = event;
        this.isDelEvent = true;
        this.openModal();
      },
      getDataField(event, field) {
        if (field === 'eventType') {
          return `${this.$t(`settings.criticalEvents.eventTypes.${event.eventType}`)}${
            event.eventValue ? ` || ${event.eventValue}` : ''
          }`;
        }

        if (field === 'reaction') {
          return `${this.$t(`settings.criticalEvents.reactions.${event.reaction}`)}${
            event.commentValue ? ` || ${event.commentValue}` : ''
          }`;
        }

        return event[field];
      },
      async getCriticalEventsData() {
        try {
          this.treeData.lists = [];
          this.loading = true;
          const type = this.selectedComputer.type === 'folder' ? 2 : 0;
          const { data } = await getCriticalEvents(this.selectedComputer.id, type);
          if (data?.success) {
            this.treeData.lists = data.result;
            this.initData = data.result;
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.loading = false;
        }
      },
      updateCriticalEvents(events) {
        this.treeData.lists = events;
        this.$store.commit('settings/addCriticalEventsSettings', events);
        this.closeModal();
      },

      editEvent(event) {
        this.currentEvent = event;
        this.openModal();
      },
    },
  };
</script>

<style lang="scss" module>
  .card {
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    margin: 5px 0px 15px 22px;
    width: 92%;
    padding: 5px;
    > :not(:last-child) {
      border-bottom: 0.2px solid #eee;
    }
  }

  .table {
    width: 100%;
    margin-bottom: 15px;
    border-collapse: collapse;
    font-weight: 400;
    word-break: break-word;
    border: 1px solid $borderColor;
    padding-bottom: 20px;
  }

  .header {
    background: #dbf1ff;
    height: 31px;
    td {
      border: 1px solid $borderColor;
      align-items: center;
      text-align: center;
      color: #232326;
      letter-spacing: -0.08px;
      font-size: 13px;
      padding: 4px;
      cursor: pointer;
      vertical-align: middle;
    }
  }

  .tdInline {
    display: inline-flex;
  }

  .arrow {
    float: right;
    margin-top: 7px;
    margin-right: 5px;

    &.asc {
      transform: rotate(180deg);
    }

    &.hidden {
      visibility: hidden;
    }
  }

  .item {
    height: 29px;
    cursor: pointer;

    &:hover {
      background: $light-gray;
    }

    td {
      border: 1px solid $borderColor;
      align-items: center;
      letter-spacing: -0.24px;
      color: $black;
      font-weight: 300;
      font-size: 13px;
      line-height: 14px;
      text-align: center;
      padding: 5px;
      vertical-align: middle;
    }
  }

  .buttonsContainer {
    display: inline-flex;
    margin-bottom: 10px;
  }

  .buttonContainer {
    width: 50%;
  }

  .addUserButton {
    border: 1px solid white;
    background: #2985bf;
    cursor: pointer;
    height: 30px;
    color: white;
    width: 100%;
  }

  .modal {
    display: flex;
    z-index: 3000;
  }
</style>
